import React from 'react';
import styles from './ExternalClient.module.scss';
import Label from 'components/Label/Label';

const ExternalClient = () => {
  return (
    <Label
      color="primary"
      inverse={true}
      title="This client has not validated their account on Twine. They will be emailed your application."
      className={styles.externalClientBadgeLabel}
    >
      External Client
    </Label>
  );
};

export default ExternalClient;
